import type { JSX } from "react";
import * as RdSeparator from "@radix-ui/react-separator";
import type { SpacingLevel } from "./Spacing";
import { SpacingX, SpacingY } from "./Spacing";

type SeparatorOrientation = "vertical" | "horizontal";

export type SeparatorProps = {
  orientation?: SeparatorOrientation;
  className?: string;
  color?: string;
  spacingLevel?: SpacingLevel;
}

const getSeparatorOrientationClasses = (orientation: SeparatorOrientation): string => {
  switch (orientation) {
    case "vertical": {
      return "border-r h-full w-px";
    }
    case "horizontal": {
      return "border-t h-px w-full";
    }
    default: {
      return "";
    }
  }
};

const getWrapperOrientationClasses = (orientation: SeparatorOrientation): string => {
  switch (orientation) {
    case "vertical": {
      return "h-full";
    }
    case "horizontal": {
      return "flex-col w-full";
    }
    default: {
      return "";
    }
  }
};

const getSpacerByOrientation = (orientation: SeparatorOrientation, level?: SpacingLevel): JSX.Element => {
  switch (orientation) {
    case "vertical": {
      return <SpacingX level={level} />;
    }
    case "horizontal": {
      return <SpacingY level={level} />;
    }
    default: {
      return <div></div>;
    }
  }
};

export const Separator = ({
  orientation = "horizontal",
  className = "",
  color = "border-gray-400",
  spacingLevel = 6,
  ...props
}: SeparatorProps) => (
  <div className={`flex ${getWrapperOrientationClasses(orientation)}`}>
    {getSpacerByOrientation(orientation, spacingLevel)}
    <RdSeparator.Root
      {...props}
      orientation={orientation}
      decorative
      className={`${color} ${className} ${getSeparatorOrientationClasses(orientation)} ${className}`}
    />
    {getSpacerByOrientation(orientation, spacingLevel)}
  </div>
);
